<div *ngIf="!!product; else loading">
  <div class="row pt-2">
    <div class="col-12">
      <lib-back-button class="ml-5"></lib-back-button>
    </div>
  </div>

  <div class="row pt-1 product-detail-data-section">
    <!-- Product img -->
    <div class="col-xs-12 col-sm-6 container">
      <div class="row">
        <div class="col-auto">
          <img
            *ngIf="product.extra.images && product.extra.images[selectedImageIndex] as image; else noimage"
            src="https://cdn1.gung.io/fit-in/400x400/filters:fill(white):background_color(white):etag({{
              image.s3ETag
            }}):format(jpeg)/{{ image.s3Uri }}"
            alt="{{ image.description }}"
            class="img-fluid"
          />
          <ng-template #noimage>
            <img
              class="card-img-top img-fluid w-100"
              src="https://cdn1.gung.io/fit-in/300x300/images/no-image.jpg"
              alt="NO IMAGE"
              class="img-fluid mx-auto d-block"
            />
          </ng-template>
        </div>
      </div>

      <!-- Product Images carousel -->
      <div *ngIf="!!carousel">
        <div *ngIf="carousel.images.length > 1" class="row pt-2">
          <button
            type="button"
            class="btn col-1"
            [disabled]="carousel.startIndex === 0"
            (click)="scrollImages('left')"
            *ngIf="!carousel.containsAll"
          >
            <i class="fa fa-chevron-left product-images-carousel"></i>
          </button>

          <div *ngFor="let image of carousel.images; trackBy: trackByFn" class="col-3 pb-1 product-detail-image">
            <img
              src="https://cdn1.gung.io/fit-in/100x100/filters:fill(white):background_color(white):etag({{
                image.s3ETag
              }}):format(jpeg)/{{ image.s3Uri }}"
              alt="{{ image.description }}"
              class="img-fluid"
              (click)="setSelectedImage(image.s3Uri)"
            />
          </div>

          <button
            type="button"
            class="btn col-1"
            [disabled]="carousel.endIndex + 1 === carousel.countAll"
            (click)="scrollImages('right')"
            *ngIf="!carousel.containsAll"
          >
            <i class="fa fa-chevron-right product-images-carousel"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Product data -->
    <div class="col-xs-12 col-sm-6">
      <div class="row">
        <div class="col-12">
          <h5 class="mb-0">
            <!-- <span>{{ 'ITEM_NO' | translate }}</span>:  -->
            {{ product.id }}
            <span *ngIf="product.extra.ar?.artnrean" class="text-muted">({{ product.extra.ar.artnrean }})</span>
          </h5>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h1>{{ product.name }}</h1>
        </div>
      </div>

      <div class="row" *ngIf="getProductDescription() | async as productDescription">
        <div class="col-12">
          <p>{{ productDescription }}</p>
        </div>
      </div>

      <div class="row" *ngIf="product?.extra?.pim?.notes">
        <div class="col-12">
          <b>{{ 'NOTES' | translate | uppercase }}</b>
          <p class="font-weight-light" style="white-space: pre-wrap">{{ product.extra.pim.notes }}</p>
        </div>
      </div>

      <div class="row" *ngIf="flow?.useAvailabilities">
        <div class="col-12">
          <i class="fas fa-box"></i>&nbsp;
          <lib-availability [availability]="availability" [isSales]="isSales"></lib-availability>
        </div>
      </div>
      <div class="row mt-2" *ngIf="price?.backendPrice?.levels?.[0]?.extra?.campaign">
        <div class="col">
          <span class="campaign-banner">
            <span translate>CAMPAIGN_UNTIL</span> {{ price.backendPrice.levels[0].extra.campaign.kampanjtomdat | date:'yyyy-MM-dd' }}
          </span>
        </div>
      </div>

      @if (product.extra.ar?.itemstatuscode !== 98) {
      <div class="row mt-3">
        <div class="col">
          @if (price?.backendPrice?.levels?.[0]?.extra?.campaign?.ordinaryPrl?.vb_pris) {
            <div class="mb-0 mt-3">
              <span class="original-price" [class.blur]="hidePrice">
                {{ price.backendPrice.levels[0].extra.campaign.ordinaryPrl.vb_pris | number: '1.2-2' }} {{ price.customerGrossPrice.currencyCode }}
              </span>
            </div>
          }
          <h4 class="mt-1">
            <!-- <span>{{ 'NET_PRICE' | translate }}</span>: -->
            <div>
              <span *ngIf="price.customerDiscountPercent !== 0; else noDiscount">
                <car-liner-price
                  [price]="price"
                  [display]="'code'"
                  type="GROSS"
                  [currency]="price.customerGrossPrice.currencyCode"
                  class="font-weight-bold"
                ></car-liner-price
                >&nbsp;
                <span [class.blur]="hidePrice">
                  (-{{ price.customerDiscountPercent }}% = {{ price.customerNetPrice.value | number: '1.2-2' }})
                </span>
              </span>
              <ng-template #noDiscount>
                <car-liner-price
                  [price]="price"
                  [display]="'code'"
                  type="NET"
                  [currency]="price.customerNetPrice.currencyCode"
                  class="font-weight-bold"
                ></car-liner-price>
                @if (price.backendPrice?.levels?.[0]?.extra?.prl?.nettoejrabkod == '1') {
                  <span class="ml-2" translate>PRODUCT_WITHOUT_DISCOUNT</span>
                }
              </ng-template>
            </div>
          </h4>
        </div>
      </div>

      <!-- <div class="row" *ngIf="price.backendPriceLevel.extra.ApproximatePrice">
          <div class="col">
            <h5>
              <span>{{ 'RRP' | translate }}</span>:
              <strong>{{price.backendPriceLevel.extra.ApproximatePrice | gungCurrency: price.backendPriceLevel.extra.CurrencyCode:'code' }}</strong>
            </h5>
          </div>
        </div> -->

      <div class="row" *ngIf="!isOnlyDisplayFlow">
        <div class="col-12 col-md-6">
          <lib-buy-btn [id]="product.id" [product]="product"></lib-buy-btn>
        </div>
      </div>

      <!-- Product Jeeves Details -->
      <div class="pt-2">
        <lib-gung-accordion
          #acc="gungAccordion"
          [destroyOnHide]="false"
          activeIds="jeeves-product-details"
          class="accordion-jeeves-product-details"
        >
          <lib-gung-accordion-item id="jeeves-product-details" [collapsed]="false">
            <ng-template libGungAccordionHeader>{{ 'PRODUCT_DETAILS' | translate }}</ng-template>
            <ng-template libGungAccordionBody>
              <div class="table-responsive">
                <table class="table table-borderless table-striped table-sm">
                  <tbody>
                    <tr *ngIf="product.extra.ar.q_farg">
                      <th width="35%" translate>COLOR</th>
                      <td>
                        <span>{{ product.extra.ar.q_farg }}</span>
                      </td>
                    </tr>
                    <tr *ngIf="product.extra.ar.artvikt">
                      <th width="35%" translate>NET_WEIGHT</th>
                      <td>
                        <span>{{ product.extra.ar.artvikt }}</span
                        ><span> kg</span>
                      </td>
                    </tr>
                    <tr *ngIf="product.extra.ar?.artbtotvikt">
                      <th width="35%" translate>GROSS_WEIGHT</th>
                      <td>
                        <span>{{ product.extra.ar?.artbtotvikt }}</span
                        ><span> kg</span>
                      </td>
                    </tr>
                    <tr *ngIf="product.extra.ar.artvolym">
                      <th width="35%" translate>VOLUME</th>
                      <td>
                        <span>{{ product.extra.ar.artvolym }}</span
                        ><span> m3</span>
                      </td>
                    </tr>
                    <ng-container>
                      <tr *ngIf="isJosam && product.extra.ar.enhetskod">
                        <th width="35%" translate>UNIT</th>
                        <td>{{ product.extra.ar.enhetskod }}</td>
                      </tr>
                      <tr *ngIf="product.extra.ar.artstatnr">
                        <th width="35%" translate>TARIFF_CODE</th>
                        <td>{{ product.extra.ar.artstatnr }}</td>
                      </tr>
                    </ng-container>
                    <tr *ngIf="product.extra.ar.ersatterartnr">
                      <th width="35%" translate>REPLACES_NUMBER</th>
                      <td>
                        <span>{{ product.extra.ar.ersatterartnr }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-template>
          </lib-gung-accordion-item>

          <lib-gung-accordion-item id="jeeves-product-documents" *ngIf="product?.extra?.documents?.length > 0" [collapsed]="false">
            <ng-template libGungAccordionHeader>{{ 'DOCUMENTS' | translate }}</ng-template>
            <ng-template libGungAccordionBody>
              <div class="table-responsive">
                <table class="table table-hover table-borderless table-striped table-sm">
                  <thead>
                    <tr>
                      <th translate>NAME</th>
                      <th class="text-right" translate>DOWNLOAD_DOCUMENT</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let document of product.extra.documents">
                      <td>
                        {{
                          document.i18n[currentLang]?.description
                            ? document.i18n[currentLang].description
                            : document.category
                        }}
                      </td>
                      <td class="text-right">
                        <a target="_NEW" [href]="'https://cdn2.gung.io/' + document.s3Uri">
                          <span translate>{{ document.s3Uri && document.s3Uri.split('/').reverse()[0] }}</span>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-template>
          </lib-gung-accordion-item>
        </lib-gung-accordion>
      </div>
      }
    </div>
  </div>

  <div class="row mt-3 product-detail-data-section">
    <div class="col-12">
      <lib-gung-tabset
        *ngIf="
          addonIds.length > 0
          || pimRelatedProductsIds.length > 0
          || includedItemIds.length > 0
          || powerUnits.length > 0
          || sparePartsIds.length > 0
          || (product?.extra.pim?.spareParts != '' && product?.extra.pim?.spareParts?.split(',')?.length > 0)
        "
        [activeId]="activeTab"
        (tabChange)="tabChanged($event)"
      >
        <lib-gung-tab
          id="included-items"
          *ngIf="includedItemIds.length > 0 &&
            ((!isJosam || sparePartsIds.length === 0) &&
            (!isJosam || product.extra.ar.itemtypecd6 === 1))"
          [title]="isJosam ? ('JOSAM_INCLUDED_ITEMS' | translate) : ('INCLUDED_ITEMS' | translate)"
        >
          <ng-template libGungTabContent>
            <car-liner-included-items-by-ids
              [productIds]="includedItemIds"
              [parentId]="product.id"
            ></car-liner-included-items-by-ids>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab id="spare-parts" *ngIf="sparePartsIds.length > 0 && (product?.extra.pim?.spareParts == '' || product?.extra.pim?.spareParts?.split(',')?.length == 0)" [title]="'SPARE_PARTS' | translate">
          <ng-template libGungTabContent>
            <car-liner-product-list-by-ids
              [productIds]="sparePartsIds"
              [recommendedQuantities]="product.extra._reservePartIdsRecommendedQuantities"
            ></car-liner-product-list-by-ids>
            <!-- <car-liner-included-items-by-ids
              [productIds]="sparePartsIds"
              [parentId]="product.id"
            ></car-liner-included-items-by-ids> -->
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab id="addons" *ngIf="addonIds.length > 0 && product" [title]="'ADDONS' | translate">
          <ng-template libGungTabContent>
            <car-liner-product-list-by-ids [productIds]="addonIds" [product]="product" [isAddons]="true"></car-liner-product-list-by-ids>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab id="power-units" *ngIf="powerUnits.length > 0" [title]="'POWER_UNITS' | translate">
          <ng-template libGungTabContent>
            <car-liner-product-list-by-ids [productIds]="powerUnits"></car-liner-product-list-by-ids>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab id="related-products" *ngIf="pimRelatedProductsIds.length > 0" [title]="'PRODUCT_RELATED_PRODUCTS' | translate">
          <ng-template libGungTabContent>
            <car-liner-product-list-by-ids [productIds]="pimRelatedProductsIds"></car-liner-product-list-by-ids>
          </ng-template>
        </lib-gung-tab>
        @if (product?.extra.pim?.spareParts != '' && product?.extra.pim?.spareParts?.split(',')?.length > 0) {
          <lib-gung-tab id="spare-parts" [title]="'SPARE_PARTS' | translate">
            <ng-template libGungTabContent>
              <car-liner-product-list-by-ids
                [productIds]="product.extra.pim.spareParts.split(',')"
                [recommendedQuantities]="product.extra._reservePartIdsRecommendedQuantities"
              ></car-liner-product-list-by-ids>
            </ng-template>
          </lib-gung-tab>
        }
      </lib-gung-tabset>
    </div>
  </div>
</div>

<ng-template #loading> LOADING... </ng-template>
